import { useCallback, useEffect, useState } from "react";
import PortalPaymentsService from "../../../services/portalPayment";

export const useFetchPaymentProviders = () => {
  const [providers, setProviders] = useState<any[]>([]);

  const [selectedProvider, setSelectedProvider] = useState<any>(null);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchProviders = useCallback(async () => {
    try {
      const res: any = await PortalPaymentsService.fetchProviders();

      if (res.length > 0) {
        const values: any[] = res
          .filter((item: any) => item.isEnabled)
          .map((item: any, i: number) => ({
            ...item,
            i,
          }));
        setProviders(values);

        setSelectedProvider(values[0]);
      }

      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProviders();
  }, [fetchProviders]);

  return { providers, isLoading, selectedProvider, setSelectedProvider };
};
